import { useSnackbar } from "notistack";

/**
 * useNotification - Custom hook for showing snackbars via notistack
 *
 * @param {object} defaultOptions - Optional customization for snackbar behavior
 * @returns Notification methods: success, error, info, warning
 */
export const useNotification = (defaultOptions = {}) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const notify = (message, variant = "default", options = {}) => {
    const colourPatch =
      variant === 'success'
        ? { style: { backgroundColor: '#005cff', color: '#fff' } }
        : {};
    enqueueSnackbar(message, {
      variant,
      ...colourPatch,
      ...defaultOptions,
      ...options,
    });
  };

  return {
    notifySuccess: (msg, opts) => notify(msg, "success", opts),
    notifyError: (msg, opts) => notify(msg, "error", opts),
    notifyInfo: (msg, opts) => notify(msg, "info", opts),
    notifyWarning: (msg, opts) => notify(msg, "warning", opts),
    notifyDefault: (msg, opts) => notify(msg, "default", opts),
    closeNotify: closeSnackbar,
  };
};
